import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./auth";
import social from "./social";
import navigation from "./navigation";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        auth,
        social,
        navigation
    },
    strict: debug
})
